import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ConversationActionBar } from '@/Domain/components/Inbox/ConversationActionBar/ConversationActionBar';
import { MessageInput } from '@/Domain/components/Inbox/MessageInput/MessageInput';
import { MessageList } from '@/Domain/components/Inbox/MessageList/MessageList';
import { Spinner } from '@/Domain/components/Shared/Spinner';
import { useConversationEvents } from '@/Domain/hooks/Conversation/useConversationEvents.hook';
import { useGetConversation } from '@/Domain/hooks/Conversation/useGetConversation.hook';
import { useUpdateConversation } from '@/Domain/hooks/Conversation/useUpdateConversation.hook';
import { useUser } from '@/Domain/hooks/User/useUser.hook';
import { useChangeStatus } from '@/Domain/socket/Conversation/useChangeStatus.socket';
import { useConversationAssignee } from '@/Domain/socket/Conversation/useConversationAssignee.socket';
import { useConversationEvent } from '@/Domain/socket/Conversation/useConversationEvent.socket';
import { useConversationStore } from '@/Domain/store/conversation.store';

export const Conversation = () => {
  const { id } = useParams() as { id: string };

  const { user } = useUser();
  const { handleUpdate } = useUpdateConversation(id);
  const { conversation } = useGetConversation(id);
  const { setMessage } = useConversationStore();

  const {
    events,
    isLoading,
    isFetchingNextPage,
    onLoadMore,
    hasNextPage = true,
  } = useConversationEvents(id);

  useConversationEvent(id);
  useConversationAssignee(id);
  useChangeStatus(id);

  useEffect(() => {
    if (conversation?.has_unread_messages) {
      handleUpdate({ has_unread_messages: false });
    }
  }, [id, conversation]);

  useEffect(() => () => setMessage(null), [id]);

  if (isLoading || !conversation) {
    return (
      <div className="flex flex-1 justify-center items-center">
        <Spinner className=" h-7 w-7" />
      </div>
    );
  }

  return (
    <div className="flex w-full flex-1 flex-col bg-background p-4">
      <ConversationActionBar conversation={conversation} userEmail={user?.email || ''} id={id} />
      <MessageList
        loading={isFetchingNextPage}
        hasNextPage={hasNextPage}
        isLoading={isLoading}
        events={events}
        onLoadMore={onLoadMore}
        id={id}
      />

      {conversation.supports_inbox_control && <MessageInput conversation={conversation} />}
    </div>
  );
};
